export default __webpack_public_path__ + "assets/images/5.62318f.webp";